import { CheckboxOutput } from '../../team-apis/otterdam/outputs/checkbox-output';
import { ImageAnnotationOutput } from '../../team-apis/otterdam/outputs/image-annotation-output';
import {
  AbstractOutput,
  AbstractOutputWithAnswerOptions,
} from '../../team-apis/otterdam/outputs/output';
import { PointCloudOutput } from '../../team-apis/otterdam/outputs/point-cloud-output';
import { SensorFusionOutput } from '../../team-apis/otterdam/outputs/sensor-fusion-output';
import { VideoOutput } from '../../team-apis/otterdam/outputs/video-output';
import { Project } from '../../team-apis/otterdam/project';

export function isCheckboxOutput(
  output: AbstractOutput,
): output is CheckboxOutput {
  return output.type === 'CheckboxOutput';
}

export function isSensorFusionOutput(
  output: AbstractOutput,
): output is SensorFusionOutput {
  return output.type === 'SensorFusionOutput';
}

export function isVideoOutput(output: AbstractOutput): output is VideoOutput {
  return output.type === 'VideoOutput';
}

export function isImageAnnotationOutput(
  output: AbstractOutput,
): output is ImageAnnotationOutput {
  return output.type === 'ImageAnnotationOutput';
}

export function isPointCloudOutput(
  output: AbstractOutput,
): output is PointCloudOutput {
  return output.type === 'PointCloudOutput';
}

export function isOutputWithAnswerOptions(
  output: AbstractOutput,
): output is AbstractOutputWithAnswerOptions {
  return output.hasOwnProperty('answer_options');
}

export function getFirstVideoNotOrthographicOutput(project: Project) {
  return project.outputs.find(
    (output) =>
      isVideoOutput(output) && !output.meta.is_orthographic_projection,
  );
}

export function isOrthographicVideoOutput(
  output: AbstractOutput,
): output is VideoOutput {
  return isVideoOutput(output) && output.meta.is_orthographic_projection;
}
